import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { fetchFullCalendarEventAndUpdateItemResponseShapeType } from '../../helpers/eventStore';
import {
    InfoBarMessageViewState,
    InfoBarMessageSource,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { InfoBarViewStates } from 'owa-calendar-info-bar/lib/utils/allViewStates';

export default (event: CalendarEvent, source: InfoBarMessageSource): InfoBarMessageViewState[] => {
    let showBlockedExternalContent = async () => {
        const {
            fullEventPromise,
        } = fetchFullCalendarEventAndUpdateItemResponseShapeType(
            event.ItemId,
            'WithBlockedExternalContent',
            null,
            () => event as CalendarEvent /* getExistingCalendarEvent */,
            false /** isfetchFullSeriesMasterCalendarEventFromEventInstance */,
            { fetchSource: getFetchSource(source) }
        );
        await fullEventPromise;
    };

    return event.HasBlockedImages
        ? [
              InfoBarViewStates.getInfobarViewStateForBlockedExternalContent({
                  showBlockedExternalContent: showBlockedExternalContent,
                  source: source,
              }),
          ]
        : [];
};

function getFetchSource(source: InfoBarMessageSource): string {
    switch (source) {
        case InfoBarMessageSource.Compose:
            return 'FullComposeEdit';
        case InfoBarMessageSource.ReadingPane:
            return 'ReadingPane';
        case InfoBarMessageSource.Peek:
            return 'Peek';
        case InfoBarMessageSource.CalendarCard:
            return 'CalendarCard';
        default:
            return '';
    }
}
